// extracted by mini-css-extract-plugin
export default {"main":"et_main__zYwNj","h2":"et_h2__+B2HM","h3":"et_h3__btmuB","description":"et_description__E9otY","full_img":"et_full_img__8mT5j","ul":"et_ul__VJT44"};